<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey">
            <TabPane key="Children" :tab="$t('model.fishingTool.children')">
                <ChildrenList
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="{...data}"
                    itemsKey="children"
                    :fetchCriteria="data.children?.fetchCriteria"
                    :visibleParent="false"
                ></ChildrenList>
            </TabPane>
        </Tabs>
        <ChangeLogCollapse
            class="mt-2"
            v-if="visibleChangeLog && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="data.fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../../app.logic";
import { onCallChangeLog } from "../../../../../utils/form";
import { callChanges, createFormTitle, createSearchOneCriteria, initForm, isLoading, onClickModalOk, state } from "./fishing-tool.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../../../components/change-log/ChangeLogCollapse")),
        ChildrenList: defineAsyncComponent(() => import("./ChildrenList"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "fishing-tools" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        isChild: { default: false }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callChanges,
            callOnClickModalOk,
            createSearchOneCriteria,
            onCallChangeLog
        };
    }
});
</script>
